import styled from 'styled-components';

export const StyledFacebookSignIn = styled.div`
  .facebook-sign-in {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    padding: 10px 24px;
    background-color: #1877f2;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background-color: #166fe5;
    }

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }

    &__icon {
      font-size: 20px;
    }

    &__text {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    }

    &__circle {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #1877f2;
      border: none;
      cursor: pointer;

      &:hover {
        background-color: #166fe5;
      }

      &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
      }
    }

    &__circle-icon {
      font-size: 24px;
      color: white;
    }
  }
`;
